"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Endpoint = void 0;
const utils_1 = require("../utils");
const auth_1 = require("../auth");
class Endpoint {
    constructor({ url, init, payload, options }) {
        this._isDebug = false;
        this._url = url;
        this._init = Object.assign(Object.assign({}, init), options === null || options === void 0 ? void 0 : options.init);
        this._payload = payload;
        this._onRefreshFail = options === null || options === void 0 ? void 0 : options.onRefreshFail;
    }
    get url() {
        return this._url;
    }
    setDebugMode(isActive) {
        this._isDebug = isActive;
    }
    _fetchApi() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.fetchApi)(this._url, this._init, this._payload);
        });
    }
    _refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return auth_1.auth.refreshToken()._fetchApi();
        });
    }
    _debugResponse(res, text) {
        if (!this._isDebug)
            return;
        text && console.log(text);
        console.log('Init request: ', this._init);
        console.log('Payload: ', this._payload);
        if (res instanceof utils_1.FetchError) {
            console.log('Error response: ', res.response);
            console.log('Errors: ', res.data.errors);
        }
        else {
            console.log('Success: ', res);
        }
    }
    fetch() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._fetchApi();
            this._debugResponse(res, `Endpoint: ${this._url}`);
            if (res instanceof utils_1.FetchError && res.response.status === 401 && typeof window !== 'undefined') {
                const rtRes = yield this._refreshToken();
                this._debugResponse(rtRes, 'Refresh token response: ');
                if (rtRes instanceof utils_1.FetchError) {
                    yield ((_a = this._onRefreshFail) === null || _a === void 0 ? void 0 : _a.call(this));
                    return res;
                }
                const retryRes = yield this._fetchApi();
                this._debugResponse(retryRes, 'Retry response: ');
                return retryRes;
            }
            return res;
        });
    }
    unwrap() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.fetch();
            if (res instanceof utils_1.FetchError) {
                throw new utils_1.FetchError(res);
            }
            return res;
        });
    }
}
exports.Endpoint = Endpoint;
